import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { HttpService } from '../services/http/http.service';
import {BasicResponse, UserLoginView} from "@model";
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly api:HttpService
  ) { }
  roles: any[] | null = null;
  loadingRoles = true;
  breadLinks:any={
    'firstLink':{
      'name':'Home',
      'link':'/'
    },
    'secondLink':{
      'name':'',
      'link':''
    },
    'thirdLink':{
      'name':'Profili',
      'link':''
    }
  }
  ngOnInit(): void {
    this.auth.authLogin().subscribe({
      next: (response: any) => {
        sessionStorage.setItem('CF', response.result.codiceFiscale);
        sessionStorage.setItem('userInfo', JSON.stringify(response.result));
        let cf = sessionStorage.getItem('CF') ?? '';
        this.auth.userRoles(cf).subscribe({
          next: (response: any) => {
            this.roles = response.result ?? [];
            this.loadingRoles = false;
            if (this.roles?.length === 0) {
              this.breadLinks.thirdLink = '';
            }
          },
          error: () => {
            this.resetOnError();
          }
        });
      },
      error: () => {
        this.resetOnError();
      }
    });
  }

  resetOnError(): void {
    this.roles = [];
    this.loadingRoles = false;
    this.breadLinks.thirdLink = '';
  }

  toHome(roleId:any): void {
    this.api.setRuoloAttivo(roleId).subscribe({
      next: () => {
        this.auth.authLogin().subscribe({
          next: (response: BasicResponse<UserLoginView>) => {
            sessionStorage.setItem('userInfo',JSON.stringify(response.result));
            this.router.navigate(['secured/home']);
          }
        })
      }
    })
  }
}
